import React from 'react';
import { Typography } from '@hmsexp/component-library';
import { View } from '../Common/react-native-components';
import styles from './styles';
import BrandIcon from '../../../../common/icons/BrandIcon';

const Footer = () => {
  
  return (
    <View style={styles.footer}>
      <View style={styles.footerContent}>
        <View style={styles.poweredByContainer}>
          <Typography variant="body2" textProps = {{style : styles.poweredBy}}>
            Powered by
          </Typography>
          <BrandIcon fillOS="#f8f9fa" width={100} height={24}/>
        </View>
      </View>
    </View>
  );
};

export default Footer;